import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';

class AdminIndividualExtResComponent extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
            modifyView: 'default',
    		data:{
                extResourceId: '',
                extResourceName: '',
                extResourceLink: '',
                extResourceType: '',
                extResourceDescription: '',
                extResourceAuthor: '',
                extResourceDate: ''
    		},
            inputData:{
                extResourceId: '',
                extResourceName: '',
                extResourceLink: '',
                extResourceType: '',
                extResourceDescription: '',
                extResourceAuthor: ''
            },
            fileError: '',
            uploadDisableButton: false,
            addDisableButton: false,
            errorMsg: ''
    	}
    }

    handleNameChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.extResourceName = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleLinkChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.extResourceLink = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleAuthorChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.extResourceAuthor = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleDescChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.extResourceDescription = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleModifyResource = (e) =>{
        let data = Object.assign({}, this.state.data)
        let modifyView
        if(this.props.extResourceType == 'link'){
            modifyView = 'link_modify'
        }
        else if (this.props.extResourceType == 'document'){
            modifyView = 'doc_modify'
        }
        this.setState({modifyView: modifyView, inputData: data, errorMsg: '', fileError: ''})
    }

    handleDisableResource = (e) =>{
        this.setState({errorMsg: ''})
        api.adminExternalDisableResource(this.props.user.accessToken, this.props.extResourceId)
        .then((result) => {
            if (result.status == 'success') {
                this.setState({errorMsg: 'Resource has been disabled.'})
            }
            else{
                this.setState({errorMsg: 'Resource has not been disabled.'})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'There seems to be a problem disabling the resource.' })
        })
    }

    handleModifyResourceClose = (e) =>{
        let modifyView = 'default'
        this.setState({modifyView: modifyView, errorMsg: ''})
    }

    handleModifyLinkResourceSave = (e) =>{
        e.preventDefault()
        if ((this.state.inputData.extResourceName == '') || (this.state.inputData.extResourceAuthor == '') || (this.state.inputData.extResourceLink == '') || (this.state.inputData.extResourceDescription == '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before modifying a resource.'})
        }
        let type = 0
        this.setState({addDisableButton: true})
        let data = {
            'extResource':
                {
                    'name' : this.state.inputData.extResourceName,
                    'resourceLink' : this.state.inputData.extResourceLink,
                    'author': this.state.inputData.extResourceAuthor,
                    'description': this.state.inputData.extResourceDescription
                }
        }

        api.adminExtUpdateResource(this.props.user.accessToken, data, this.props.extResourceId, type)
        .then((result) => {
            if(result.status == 'success'){
                let data = Object.assign({}, this.state.data)

                data.extResourceId = result.data.resource.id
                data.extResourceName = result.data.resource.name
                data.extResourceAuthor = result.data.resource.author
                data.extResourceDescription = result.data.resource.description
                data.extResourceLink = result.data.link
                let modifyView = 'default'
                this.setState({data: data, modifyView: modifyView, addDisableButton: false})
            }
            else{
                this.setState({ errorMsg: 'Error in modifying(Link Resource) the existing External Resources.', addDisableButton: false})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in modifying(Link Resource) the External Resources. Please contact Admin!', addDisableButton: false})
        })
    }

    handleModifyResourceUpload = (e) =>{
        e.preventDefault()
        if ((this.state.inputData.extResourceName == '') || (this.state.inputData.extResourceAuthor == '') || (this.state.inputData.extResourceDescription == '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before uploading a new resource.'})
        }

        let type = 1
        const formData = new FormData(e.target);
        this.setState({uploadDisableButton: true})

        api.adminExtUpdateDocResource(this.props.user.accessToken, formData, this.props.extResourceId, type)
        .then((result) => {
            if(result.status == 'success'){
                let data = Object.assign({}, this.state.data)

                data.extResourceId = result.data.resource.id
                data.extResourceName = result.data.resource.name
                data.extResourceAuthor = result.data.resource.author
                data.extResourceDescription = result.data.resource.description
                data.extResourceLink = result.data.link
                let modifyView = 'default'
                this.setState({data: data, modifyView: modifyView, uploadDisableButton: false})
            }
            else{
                this.setState({ errorMsg: 'Error in modifying(Document Resource) the existing External Resources.', uploadDisableButton: false})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in modifying(Document Resource) the External Resources. Please contact Admin!', uploadDisableButton: false})
        })
    }

    validateUpload = (event) =>{
        let file_name = event.target.files[0].name;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();
        let uploadDisableButton
        let fileError

        if (extension == "pdf"){
            uploadDisableButton = false
            fileError = ''
            this.setState({uploadDisableButton: uploadDisableButton, fileError: fileError})
        }
        else {
            uploadDisableButton = true
            fileError = 'Invalid File Format. Upload PDF file only.'
            this.setState({uploadDisableButton: uploadDisableButton, fileError: fileError})
        }
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)
        let inputData = Object.assign({}, this.state.inputData)
        data.extResourceId = this.props.extResourceId
        data.extResourceName = this.props.extResourceName
        data.extResourceLink = this.props.extResourceLink
        data.extResourceDescription = this.props.extResourceDescription
        data.extResourceAuthor = this.props.extResourceAuthor
        data.extResourceDate = this.props.extResourceDate
        inputData.extResourceId = this.props.extResourceId
        inputData.extResourceName = this.props.extResourceName
        inputData.extResourceLink = this.props.extResourceLink
        inputData.extResourceDescription = this.props.extResourceDescription
        inputData.extResourceAuthor = this.props.extResourceAuthor

        this.setState({data: data, inputData: inputData})
    }


    render(){
        let incomingComponent
        let ratingComponent
        let uploadButtonComponent
        let addButtonComponent
        let displayComponent
        let handleModifyResource = this.handleModifyResource
        let handleModifyResourceClose = this.handleModifyResourceClose
        let handleModifyLinkResourceSave = this.handleModifyLinkResourceSave
        let handleModifyResourceUpload = this.handleModifyResourceUpload
        let handleDisableResource = this.handleDisableResource

        if(this.state.uploadDisableButton == false){
            uploadButtonComponent = (<Button raised style={{ width: '100%' }}>Save</Button>)
        }
        else{
            uploadButtonComponent = (<Button raised disabled style={{ width: '100%' }}>Save</Button>)
        }

        if(this.state.addDisableButton == false){
            addButtonComponent = (<Button raised style={{ width: '100%' }} onClick= {((e) => handleModifyLinkResourceSave(e))}>Save</Button>)
        }
        else{
            addButtonComponent = (<Button raised disabled style={{ width: '100%' }}>Save</Button>)
        }

        if (this.props.extResourceRating != null) {
            let rateFloat = parseFloat(this.props.extResourceRating)
            ratingComponent = (
                <StarRatings
                    rating={rateFloat}
                    starDimension="25px"
                    starSpacing="4px"
                    starRatedColor="wheat"
                />
            )
        }
        else {
            ratingComponent = (
                <div>
                    <Typography>There are no ratings!</Typography>
                </div>
            )
        }

        if (this.state.modifyView == 'default'){
            displayComponent = (
                <div>
                    <Grid>
                        <GridCell span="3">
                           <Typography> {this.state.data.extResourceName} </Typography>
                        </GridCell>
                        <GridCell span="2">
                           <Typography> <a href={this.state.data.extResourceLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                        </GridCell>
                        <GridCell span="2">
                            <Button onClick= {((e) => handleModifyResource(e))}>Modify</Button>
                        </GridCell>
                        <GridCell span="1">
                            <Button onClick= {((e) => handleDisableResource(e))}>Disable</Button>
                        </GridCell>
                        <GridCell span="1">
                        </GridCell>
                        <GridCell span="3">
                            {ratingComponent}
                        </GridCell>
                        <GridCell span="3" className="grid-left-align">
                            <Typography align = "left"><i>Author: {this.state.data.extResourceAuthor}</i></Typography>
                            <br />
                            <Typography align = "left" use="caption">Created on {this.state.data.extResourceDate}</Typography>
                        </GridCell>
                        <GridCell span="9" className="grid-left-align">
                            <Typography align = "left"><i>Description: {this.state.data.extResourceDescription}</i></Typography>
                        </GridCell>
                    </Grid>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                    <ListDivider />
                </div>
            )
        }
        else if (this.state.modifyView == 'link_modify'){
            displayComponent = (
                <div>
                    <Grid className="opportunity-list-item">
                        <GridCell span="5">
                            <TextField fullwidth className = 'test_input' label="Name of the Resource" autoComplete="off"  name="resourcename" value = {this.state.inputData.extResourceName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="7">
                            <TextField fullwidth className = 'test_input' label="Link for the Resource" autoComplete="off"  name="resourcelink" value = {this.state.inputData.extResourceLink} onChange = {this.handleLinkChange} style={{ height: '140%' }}/>
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="3">
                            <TextField fullwidth label="Author" name="resourceauthor" value = {this.state.inputData.extResourceAuthor} onChange={this.handleAuthorChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="9">
                            <TextField textarea fullwidth label="Description" rows="1" name="resourcedesc" value = {this.state.inputData.extResourceDescription} onChange={this.handleDescChange} />
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="4"> 
                            {addButtonComponent}
                        </GridCell>
                        <GridCell span="4">
                            <Button style={{ width: '100%' }} onClick= {((e) => handleModifyResourceClose(e))}>Cancel </Button>
                        </GridCell>
                        <GridCell span="2">
                        </GridCell>
                    </Grid>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                    <ListDivider />
                </div>
            )
        }
        else if (this.state.modifyView == 'doc_modify'){
            displayComponent = (
                <div>
                    <form style={{ width: '100%' }} onSubmit= {((e) => this.handleModifyResourceUpload(e))}>
                    <Grid className="opportunity-list-item">
                        <GridCell span="9">
                            <TextField fullwidth className = 'test_input' label="Name of the Resource" autoComplete="off"  name="name" value = {this.state.inputData.extResourceName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="3">
                            <TextField fullwidth label="Author" name="author" value = {this.state.inputData.extResourceAuthor} onChange={this.handleAuthorChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="9">
                            <TextField textarea fullwidth label="Description" rows="1" name="description" value = {this.state.inputData.extResourceDescription} onChange={this.handleDescChange} />
                        </GridCell>
                        <GridCell span="3">
                            <input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
                        </GridCell>
                        <GridCell span="4"> 
                            {uploadButtonComponent}
                        </GridCell>
                        <GridCell span="4">
                            <Button style={{ width: '100%' }} onClick= {((e) => handleModifyResourceClose(e))}>Cancel </Button>
                        </GridCell>
                        <GridCell span="2">
                        </GridCell>
                    </Grid>
                    </form>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                    <StatusMessage error_msg = {this.state.fileError} />
                    <ListDivider />
                </div>
            )
        }
        
        return (
            <div>
                {displayComponent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminIndividualExtResComponent);



// WEBPACK FOOTER //
// ./src/views/admin/AdminIndividualExtResComponent.jsx